module.exports = __webpack_public_path__ + "static/media/2ABOUTSPIN_PINKSPACEORGANISM_BIANCAOFFICIAL.8d7c3209.gif";